import {
  GROUP_ID_DEVELOPER_EXECUTIVE,
  GROUP_ID_DEVELOPER_HEADQUARTERS,
  GROUP_ID_DEVELOPER_BRANCH_LEADER,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  GROUP_ID_DEVELOPER_AGENT_LEADER,
  GROUP_ID_DEVELOPER_AGENCY_ADMIN,
  GROUP_ID_DEVELOPER_SITEPLAN,
} from './groups';

export const SR_ROLE_HEADQUARTERS = [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_HEADQUARTERS];
export const SR_ROLE_SUPERVISOR = [
  GROUP_ID_DEVELOPER_EXECUTIVE,
  GROUP_ID_DEVELOPER_BRANCH_LEADER,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
];
export const SR_ROLE_SALES_MANAGER = [
  GROUP_ID_DEVELOPER_EXECUTIVE,
  GROUP_ID_DEVELOPER_BRANCH_LEADER,
  GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
];
export const SR_ROLE_SALES_ADMIN = [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_BRANCH_LEADER];
export const SR_ROLE_AGENT_LEADER = [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_AGENT_LEADER];
export const SR_ROLE_AGENCY_ADMIN = [GROUP_ID_DEVELOPER_EXECUTIVE, GROUP_ID_DEVELOPER_AGENCY_ADMIN];
export const SR_ROLE_AGENT = '910'; // 10 + 900 (FAKE ROLE. Real: 10 + user.affiliate.companyBranch.isExternal)


export const roleOptions = (isExternal = false, isBranchLeader = false) => [
  { text: 'Headquarters', value: SR_ROLE_HEADQUARTERS.join(','), description: 'Admin', disabled: isExternal || isBranchLeader },
  { text: 'Supervisor', value: SR_ROLE_SUPERVISOR.join(','), description: 'BU Leader', disabled: isExternal },
  { text: 'Sales Manager', value: SR_ROLE_SALES_MANAGER.join(','), description: 'BU Leader', disabled: isExternal },
  { text: 'Sales Admin', value: SR_ROLE_SALES_ADMIN.join(','), description: 'BU Leader', disabled: isExternal },
  { text: 'Agent Leader', value: SR_ROLE_AGENT_LEADER.join(','), disabled: !isExternal },
  { text: 'Agency Admin', value: SR_ROLE_AGENCY_ADMIN.join(','), description: 'Claim C.', disabled: !isExternal },
  { text: isExternal ? 'Agent' : 'Staff', value: GROUP_ID_DEVELOPER_EXECUTIVE },
  { text: 'Basic Siteplan', value: GROUP_ID_DEVELOPER_SITEPLAN },
];



// WEBPACK FOOTER //
// ./src/constants/roles.js